import { deleteFile } from './deleteFile';
import { createPictureCardDraggerProps } from '../../../../utils/filesManagement/createPictureCardDraggerProps';
import { ImagePreviewList } from '../../../supervisions/components/ImagePreviewList';

/**
 * Generates properties for the Dragger component from the 'antd' library. This function
 * configures the behavior of file uploads, including file preview, removal, and the
 * upload process itself (which includes a file type check and a file conversion to base64).
 *
 * @function
 * @param {function} t - The translation function from 'react-i18next'.
 * @param {function} dispatchAPI - The function to dispatch API calls.
 * @param {function} message - The function to display messages.
 * @param {Array} fileList - An array representing the list of files.
 * @param {function} setFileList - The function to update the file list state.
 * @returns {object} The properties for the Dragger component, configuring file upload behavior.
 */
export const draggerProps = (t, dispatchAPI, message, fileList, setFileList) =>
  createPictureCardDraggerProps(
    t,
    dispatchAPI,
    message,
    fileList,
    setFileList,
    deleteFile,
    (_, file) => (
      <ImagePreviewList
        file={file}
        setFileList={setFileList}
        fileList={fileList}
      />
    )
  );
